var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeactivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_445_135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.41099 3.80737C9.50493 3.80737 9.69824 3.87783 9.69824 4.09463V6.16865C9.69824 6.97983 10.3306 7.66816 11.1399 7.73682C12.7515 7.87231 14.2474 8.60581 15.3512 9.8C16.0612 10.5696 16.5671 11.4874 16.8381 12.4774C15.4018 11.0701 13.5265 10.127 11.4814 9.8542C11.4127 9.84516 11.3423 9.83975 11.2736 9.83975C10.4064 9.83975 9.70005 10.5461 9.70005 11.4133V13.2164C9.70005 13.4332 9.50674 13.5036 9.41279 13.5036C9.36582 13.5036 9.31885 13.4892 9.27007 13.4603L1.59907 8.9021C1.50693 8.8479 1.45996 8.76479 1.45996 8.6564C1.45996 8.548 1.50693 8.4667 1.59907 8.41069L9.26826 3.84893C9.31704 3.82002 9.36401 3.80737 9.41099 3.80737ZM9.41099 2.36206C9.1165 2.36206 8.81299 2.43975 8.52935 2.60776L0.860156 7.16953C-0.267187 7.8416 -0.267187 9.473 0.860156 10.1433L8.52935 14.7032C8.81299 14.8712 9.1165 14.9489 9.41099 14.9489C10.3143 14.9489 11.1436 14.2281 11.1436 13.2164V11.4133C11.1436 11.3411 11.2032 11.2851 11.2718 11.2851C11.2772 11.2851 11.2827 11.2851 11.2899 11.2869C14.1498 11.6681 16.531 13.5596 17.6077 16.1323C17.6709 16.2822 17.8046 16.3545 17.9383 16.3545C18.0919 16.3545 18.2455 16.2587 18.2906 16.0763C18.4388 15.4728 18.5146 14.8441 18.5146 14.1992C18.5146 10.0493 15.3241 6.64199 11.261 6.29873C11.1941 6.29331 11.1436 6.2373 11.1436 6.17046V4.09463C11.1436 3.08291 10.3143 2.36206 9.41099 2.36206Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_445_135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5,
    height: 18.5,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeactivateIcon);
export default __webpack_public_path__ + "static/media/deactivate-icon.e8e444468e2c464e799818192849a39d.svg";
export { ForwardRef as ReactComponent };